import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.241 2.232a3.136 3.136 0 0 0-4.407 0l-8.03 7.962a4.94 4.94 0 0 0 0 7.024 5.037 5.037 0 0 0 7.084 0l6.357-6.303a.67.67 0 0 1 .945 0 .654.654 0 0 1 0 .937l-6.357 6.304c-2.48 2.459-6.531 2.459-8.974 0-2.479-2.46-2.479-6.478 0-8.9l8.03-7.962a4.48 4.48 0 0 1 6.297 0 4.39 4.39 0 0 1 0 6.245L8.5 15.162c-1.18 1.169-3.12 1.061-4.198-.229-.855-1.14-.766-2.695.242-3.694l6.348-6.296a.67.67 0 0 1 .945 0 .654.654 0 0 1 0 .938L5.49 12.176c-.56.522-.573 1.352-.142 1.928a1.51 1.51 0 0 0 2.208.12l7.686-7.622a3.07 3.07 0 0 0 0-4.37"
    }, null, -1)
  ])))
}
export default { render: render }